import type {DefaultOptions} from '@tanstack/react-query'
import {IS_STORYBOOK, IS_SSR} from '../globals'
import {logger} from '../log'

export const log = logger('tizra/react-query')

export const gcTime = IS_SSR ? Infinity : 24 * 60 * 60 * 1000 // 24 hours

export const defaultOptions: DefaultOptions = {
  queries: {
    // We used to set this to false, thinking that a failed call was unlikely to
    // change to success by calling back. But it turns out that we can get a 502
    // error from haproxy if the server is temporarily overloaded, see
    // https://github.com/Tizra/evergreen/issues/487
    //
    // ...so it's useful to retry. The retries use an increasing back-off
    // delay, see
    // https://tanstack.com/query/latest/docs/framework/react/guides/query-retries
    //
    // We still set to false for storybook, because any error responses in that
    // context are intentional, and retries only prolong the test.
    retry: IS_STORYBOOK ? false : 3,

    // Explicitly set gcTime because it should match persister maxAge.
    gcTime,

    // The only time we want refetch for stale queries is when the component
    // mounts (i.e. the page loads) or when the result is explicitly
    // invalidated.
    refetchInterval: false,
    refetchOnMount: true,
    refetchOnReconnect: false,
    refetchOnWindowFocus: false,
  },
}
